import { create } from 'zustand';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';

const useAuthStore = create((set) => ({
  isLoggedIn: false,
  userId: '',
  username: '',
  email: '',
  role: '',
  ProfilePicture: '',
  bio: '',
  title: '',

  setUsername: (username) => set({ username }),
  setbio: (bio) => set({ bio }),
  setTitle: (title) => set({ title }),
  setProfilePicture: (ProfilePicture) => set({ ProfilePicture }),
  setRole: (role) => (set({ role })),

  checkAuth: () => {
    const token = Cookies.get('token');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        set({
          isLoggedIn: true,
          userId: decodedToken._id || '',
          username: decodedToken.username || 'User',
          email: decodedToken.email || '',
          role: decodedToken.role || 'user',
          ProfilePicture: decodedToken.profileImageURL || '',
          bio: decodedToken.bio || '',
          title: decodedToken.title || '',
          token: token,
        });
      } catch (error) {
        console.error('Failed to decode token:', error);
        set({ isLoggedIn: false, userId: '', username: '' });
      }
    } else {
      set({ isLoggedIn: false, userId: '', username: '' });
    }
  },

  logout: () => {
    Cookies.remove('token');
    set({ isLoggedIn: false, userId: '', username: '', email: '', role: '' });
  },
}));

export default useAuthStore;
